import {
  formatDate as formatDateSafe,
  formatDateTime as formatDateTimeSafe,
  parseDate,
  toDateTimeInputValue,
} from "../../../utils/date";

export const formatCurrency = (value) => {
  const amount = Number(value) || 0;

  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
  }).format(amount);
};

export const formatDate = (value) =>
  formatDateSafe(value, { fallback: "N/A", day: "2-digit", month: "short", year: "numeric" });

export const formatDateTime = (value) => formatDateTimeSafe(value, { fallback: "N/A" });

export const toDateTimeLocalValue = (value) => toDateTimeInputValue(value);

export const fromDateTimeLocalValue = (value) => {
  const parsedDate = parseDate(value);
  return parsedDate ? parsedDate.toISOString() : value || "";
};

export const normalizeStatus = (value) => Boolean(value);

export const formatUsageStats = (usedCount, usageLimit) => {
  const used = Number(usedCount) || 0;
  const limit = Number(usageLimit) || 0;

  if (limit <= 0) {
    return `${used} used`;
  }

  return `${used} / ${limit}`;
};
